import classNames from "shared/utils/classNames";

type Props = {
  title: string;
  value: string;
  className?: string;
};
export const TicketAttribute = (props: Props) => {
  const { title, value, className } = props;
  return (
    <div
      className={classNames(
        "flex flex-col gap-1 rounded-lg text-sm",
        className,
      )}
    >
      <p className="font-semibold">{title}</p>
      <p className="font-normal text-neutral-strong">{value}</p>
    </div>
  );
};
